import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserTicketTakerGameProps {
    onComplete: () => void;
}

interface PhaserTicketTakerGameState {
}

const gameConfig: GameConfig = {
    title: "Ticket Taker Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserTicketTakerGame extends React.Component<PhaserTicketTakerGameProps, PhaserTicketTakerGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserTicketTakerGameProps) {
        super(props);
        bindAllOfThis(this, PhaserTicketTakerGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserTicketTakerGame;



// WEBPACK FOOTER //
// ./src/games/TicketTakerGame/Main.tsx